import ActionType from '../../Actions/Constants/ActionType';
import IFocusableActions from '../../Actions/Interfaces/IFocusableActions';

const createDefaultActions = (): IFocusableActions => ({
    blur: ActionType.BLUR,
    down: ActionType.DOWN,
    focus: ActionType.FOCUS_CHILD,
    left: ActionType.LEFT,
    right: ActionType.RIGHT,
    select: ActionType.SELECT,
    up: ActionType.UP,
});

export default createDefaultActions;
